import { render, staticRenderFns } from "./Criar-Post.vue?vue&type=template&id=cf6403d4&scoped=true&"
import script from "./Criar-Post.vue?vue&type=script&lang=js&"
export * from "./Criar-Post.vue?vue&type=script&lang=js&"
import style0 from "./Criar-Post.vue?vue&type=style&index=0&id=cf6403d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf6403d4",
  null
  
)

component.options.__file = "Criar-Post.vue"
export default component.exports